const USE_LOCALHOST = false;
const DAYDREAMS_URL = USE_LOCALHOST ?
  'http://localhost:5000' :
  'https://pathways-imgserver.herokuapp.com';

export default class DaydreamsConnection {
  constructor(graphController) {
    this.graphController = graphController;
    this.room = "abc";
    this.devices = [];

    this.socket = io(
      DAYDREAMS_URL+'/',
      {query:{room: "abc", isHost: true}}
    );

    this.socket.on('clientsChange', (clients)=>{
      console.log("the clients are: ", clients);
      this.devices = clients;
    });

    this.socket.on('inputFromDevice', (data)=> {
      if (data.type=='tap') {
        //console.log('inputFromDevice', data);
        let urls = this.getAllCastableImageURLs();
        let randomUrl = urls[Math.floor(Math.random()*urls.length)];
        this.socket.emit('castImageToDevice', {
          device: data.from,
          url: randomUrl
        });
      }
    });
  }

  getClients() {
    return this.devices;
  }

  castImageToDevice(device, url) {
    // hack, until we figure out how to make dynamic device menuItem
    // device is e.g. "cast2" for now, substring(4) takes from char 4 ("2") to end
    let deviceNum = Number(device.substring(4)-1);
    device = this.devices[deviceNum].clientID;

    console.log('about to castImageToDevice', device, url);
    this.socket.emit('castImageToDevice', {
      device: device,
      url: url
    });
  }

  flashDeviceSymbols() {
    this.socket.emit('flashDeviceSymbols');
  }

  // helper functions

  getAllCastableImageURLs() {
    let imageUrls = [];
    this.graphController.model.nodes.forEach( (node) => {
      //console.log("node: ", node);
      if (node.image && node.image.url) {
        imageUrls.push(node.image.url);
      };
    });
    return imageUrls;
  }
}
